










































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentIntegrarRepasseMultiplo extends Vue {
  tableHeaders: any[] = [
    { text: 'Fonte Pagadora', value: 'fontePagadoraNome', align: 'left', sortable: false },
    { text: 'Prestador', value: 'prestadorNome', align: 'left', sortable: false },
  ]

  loadIntegrarRepasseMultiplo: boolean = false

  get showModalIntegrarRepasseMultiplo() { return this.getFinanceiroStore.modal.integrarRepasseMultiplo }
  set showModalIntegrarRepasseMultiplo(value: boolean) { this.getFinanceiroStore.setModal({ name: 'integrarRepasseMultiplo', value }) }

  get loadingIntegrarRepasseMultiplo() { return this.loadIntegrarRepasseMultiplo }
  set loadingIntegrarRepasseMultiplo(value: boolean) { this.loadIntegrarRepasseMultiplo = value }

  get repassesAptosAIntegrar() { return this.getFinanceiroStore.itensDeRepasseSelecionados.every((item: any) => item.acoes.PodeIntegrar) }
  get repassesNaoAptosAIntegrar() { return this.getFinanceiroStore.itensDeRepasseSelecionados.filter((item: any) => !item.acoes.PodeIntegrar) || [] }

  async integrarRepasseMultiplo() {
    this.loadingIntegrarRepasseMultiplo = true
    const response = await this.getFinanceiroStore.integrarItensDeGeracaoDeRepasseNoHis()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao integrar o(s) repasse(s).', icon: 'warning', color: '#C62828' })
      this.loadingIntegrarRepasseMultiplo = false
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: 'A integração do(s) repasse(s) foi iniciada!', icon: 'done', color: '#2E7D32' })
    this.showModalIntegrarRepasseMultiplo = false
    this.loadingIntegrarRepasseMultiplo = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
